import {useIntl} from 'react-intl'
import {POSTCODE_REGEXP} from '../../utils/constants'
import {CreateFields, SearchForAddressFormFields} from '../../types/forms'

export const useSearchForAddressFields: CreateFields<SearchForAddressFormFields> = ({
  form: {
    control,
    formState: {errors},
  },
  label = 'Enter your postcode',
}) => {
  const {formatMessage} = useIntl()

  const fields = {
    searchForAddress: {
      name: `searchForAddress` as const,
      label: label,
      defaultValue: '',
      type: 'text' as const,
      error: errors[`searchForAddress`],
      rules: {
        required: formatMessage({defaultMessage: 'This field is required.'}),
        pattern: {
          value: POSTCODE_REGEXP,
          message: 'Please specify a valid postal code',
        },
      },
      control,
    },
  }

  return fields
}
